export const OtpPasswordTranslations = {
  en: {
    otpPassword: {
      title: "Password reset",
      subtitle: "Enter the code we sent to your email {{email}}",
      invalidCode: "Please enter the 6-digit code",
      resendCode: "Resend Code",
      continueButton: "Continue",
      backToLogin: "Back to login",
    },
  },
  es: {
    otpPassword: {
      title: "Restablecer contraseña",
      subtitle: "Ingresa el código que enviamos a tu correo {{email}}",
      invalidCode: "Por favor ingresa el código de 6 dígitos",
      resendCode: "Reenviar código",
      continueButton: "Continuar",
      backToLogin: "Volver a iniciar sesión",
    },
  },
};
